document.addEventListener('DOMContentLoaded', () => {
    const googleMap = document.querySelector('.google-map');

    if ( googleMap ) {
        loadGoogleMap();
    }
});

window.initMap = function () {
    const mapElements = document.querySelectorAll(".google-map");

    mapElements.forEach(function ( element ) {
        const latitude = parseFloat(element.dataset.latitude) || 51.5255069;
        const longitude = parseFloat(element.dataset.longitude) || -0.0836207;
        const zoom = parseInt(element.dataset.zoom) || 14;
        const markerIcon = element.dataset.marker || "img/map-marker.png";

        const officeLocationEl = document.getElementById('wcl-address');
        const address = officeLocationEl ? officeLocationEl.innerHTML.trim() : "Unknown location";

        const mapOptions = {
            center: new google.maps.LatLng(latitude, longitude),
            zoom: zoom,
            panControl: false,
            zoomControl: true,
            mapTypeControl: false,
            streetViewControl: false,
            mapTypeId: google.maps.MapTypeId.ROADMAP,
            scrollwheel: false,
            styles: [
                {
                    featureType: "landscape",
                    stylers: [ { saturation: -100 }, { lightness: 65 }, { visibility: "on" } ]
                },
                {
                    featureType: "poi",
                    stylers: [ { saturation: -100 }, { lightness: 51 }, { visibility: "simplified" } ]
                },
                { featureType: "road.highway", stylers: [ { saturation: -100 }, { visibility: "simplified" } ] },
                {
                    featureType: "road.arterial",
                    stylers: [ { saturation: -100 }, { lightness: 30 }, { visibility: "on" } ]
                },
                {
                    featureType: "road.local",
                    stylers: [ { saturation: -100 }, { lightness: 40 }, { visibility: "on" } ]
                },
                { featureType: "transit", stylers: [ { saturation: -100 }, { visibility: "simplified" } ] },
                { featureType: "administrative.province", stylers: [ { visibility: "off" } ] },
                {
                    featureType: "water",
                    elementType: "labels",
                    stylers: [ { visibility: "on" }, { lightness: -25 }, { saturation: -100 } ]
                },
                {
                    featureType: "water",
                    elementType: "geometry",
                    stylers: [ { hue: "#ffff00" }, { lightness: -25 }, { saturation: -97 } ]
                },
            ],
        };

        const map = new google.maps.Map(element, mapOptions);
        const position = new google.maps.LatLng(latitude, longitude);

        const marker = new google.maps.Marker({
            position: position,
            map: map,
            visible: true,
            icon: markerIcon
        });

        const infoWindow = new google.maps.InfoWindow({
            content: `<strong>${address}</strong>`,
        });

        // Simulate marker hover on load
        infoWindow.open(map, marker);

    });
};

function loadGoogleMap() {
    if ( typeof google === 'object' && typeof google.maps === 'object' ) {
        initMap(); // Call your map initializer here
    } else {
        setTimeout(loadGoogleMap, 100); // Retry until Google Maps is ready
    }
}